import { defineComponent as _defineComponent } from 'vue'
import { language } from '@tencent/ppd-base-libs';
import { FitButton, ScreenDialog } from '@tencent/wphk-ui';
import { computed, reactive, ref } from 'vue-demi';
import { TIPS_DIALOG_LOGO } from '../../config';
import { TipsDialogData, TipsDialogLogo } from '../../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['onClick'],
  setup(__props, { expose, emit: emits }) {

expose({ showDialog, hideDialog });



const tipsDialog = ref<InstanceType<typeof ScreenDialog> | null>(null);

const tipsDialgoData = reactive<TipsDialogData>({
  title: '',
  btnText: '',
  logoType: TipsDialogLogo.Phone,
});

const tipsDialogLogo = computed(() => tipsDialgoData.logoType && TIPS_DIALOG_LOGO[tipsDialgoData.logoType]);

function onClick() {
  hideDialog();
  tipsDialgoData.onBtnClickCb?.();
}

function onClose() {
  tipsDialgoData.onCloseClickCb?.();
}

function showDialog(data: TipsDialogData) {
  Object.assign(tipsDialgoData, data);
  tipsDialog.value?.show();
}

function hideDialog() {
  tipsDialog.value?.hide();
}

return { __sfc: true,emits, tipsDialog, tipsDialgoData, tipsDialogLogo, onClick, onClose, showDialog, hideDialog, language, FitButton, ScreenDialog }
}

})